{
  "name": "schedulerpro",
  "private": true,
  "version": "3.4.5",
  "type": "module",
  "scripts": {
    "dev": "npm run build && tsx server.ts",
    "build": "rm -rf dist && mkdir -p dist && ./node_modules/.bin/tailwindcss -i index.css -o dist/bundle.css --minify && ./node_modules/.bin/esbuild index.tsx --bundle --outfile=dist/bundle.js --minify --sourcemap --loader:.tsx=tsx --loader:.ts=ts --define:process.env.NODE_ENV=\\\"production\\\" --jsx=automatic && cp index.html icon.svg manifest.json print.html dist/",
    "start": "node server.ts",
    "lint": "tsc --noEmit"
  },
  "dependencies": {
    "@jest/globals": "^30.2.0",
    "@tailwindcss/cli": "^4.2.1",
    "@tailwindcss/postcss": "^4.2.1",
    "@testing-library/jest-dom": "^6.9.1",
    "@testing-library/react": "^16.3.1",
    "@types/dompurify": "^3.0.5",
    "@types/express": "^5.0.6",
    "autoprefixer": "^10.4.27",
    "date-fns": "^4.1.0",
    "dompurify": "^3.4.0",
    "dotenv": "^17.3.1",
    "express": "^5.2.1",
    "firebase": "^12.7.0",
    "firebase-admin": "^13.7.0",
    "html-to-image": "^1.11.13",
    "lodash-es": "4.17.21",
    "motion": "^12.34.3",
    "papaparse": "^5.5.3",
    "postcss": "^8.5.8",
    "qrcode.react": "^4.2.0",
    "react": "^19.2.3",
    "react-dom": "^19.2.3",
    "react-hot-toast": "^2.6.0",
    "react-quill-new": "^3.8.3",
    "tailwindcss": "^4.0.0"
  },
  "devDependencies": {
    "@types/node": "^22.14.0",
    "@types/papaparse": "^5.5.2",
    "esbuild": "^0.25.0",
    "tsx": "^4.21.0",
    "typescript": "~5.8.2"
  }
}
